import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-for-creators',
  templateUrl: './for-creators.component.html',
  styleUrls: ['./for-creators.component.scss']
})
export class ForCreatorsComponent implements OnInit {
  catList: any;
  constructor() { }

  ngOnInit() {
    setInterval(() => {
      this.changeText();
    }, 2000);
    this.catList = [
      {
        'image': 'assets/website/homepage/Talent.jpg',
        'text1': 'Talent',
        'text2': '& Pay Per View'
      },
      {
        'image': 'assets/website/homepage/venue.jpg',
        'text1': 'Venues',
        'text2': 'Audience Chats'
      },
      {
        'image': 'assets/website/homepage/Promoters.jpg',
        'text1': 'Promoters',
        'text2': 'Streaming'
      }, {
        'image': 'assets/website/homepage/Corporate.jpg',
        'text1': 'Corporate',
        'text2': 'Creators'
      }, {
        'image': 'assets/website/homepage/Non-profit.jpg',
        'text1': 'Non-profit',
        'text2': 'Reporting'
      },
    ]
  }

  count = 0;
  hideHost = false;
  changeText() {
    let texts = ["Concert", "Show", "Festival", "Carnival", "Conference", "Summit", "Fundraiser", "and many more"];
    $('#example').fadeOut(500, () => {
      this.hideHost = this.count == texts.length - 1 ? true : false;
      $('#example').text(texts[this.count]).fadeIn(500);
    });
    if (this.count < texts.length - 1) {
      this.count++;
    } else {
      this.count = 0;
    }
  }

}
